import './assets/scss/main.scss';

import React from 'react';
import RecoilNexus from 'recoil-nexus';
import { createRoot } from 'react-dom/client';
import Modal from 'react-modal';
import { RecoilRoot } from 'recoil';
import { BrowserRouter } from 'react-router-dom';

import * as auth from '@/api/auth.service';

import App from './App';
import GameStage from './game/GameStage';

auth.setupXSRF();

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#app');

const rootEl = document.getElementById('app');
if (!rootEl) {
  throw new Error('Missing #app root');
}

createRoot(rootEl).render(
  <RecoilRoot>
    <RecoilNexus />
    <BrowserRouter>
      <App />
    </BrowserRouter>
    <GameStage />
  </RecoilRoot>,
);
